import React, { useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";
import FullScreenDropzone from "../components/FullScreenDropzone";
import Sidebar from "./Sidebar";
import { useEffect } from "react";
import { uploadFileEmitter } from "../components/UploadFileEmitter";

function Main() {
   const dropzoneRef = useRef(null);

   const pathname = useLocation();
   const isUploadPage = pathname.pathname === "/apps/upload";
   const offsets = ["/apps/file-manager", "/apps/email", "/apps/calendar"];
   const bc = document.body.classList;

   // set sidebar to offset
   offsets.includes(pathname) ? bc.add("sidebar-offset") : bc.remove("sidebar-offset");

   // auto close sidebar when switching pages in mobile
   bc.remove("sidebar-show");

   // scroll to top when switching pages
   window.scrollTo(0, 0);

   // Define a handler for file drops
   const handleDrop = (acceptedFiles) => {
      console.log("✅ Files dropped in Main.jsx:", acceptedFiles);
      uploadFileEmitter.emit("filesDropped", acceptedFiles);
   };

   const handleDropReject = (rejectedFiles) => {
      console.log("❌ Files rejected in Main.jsx:", rejectedFiles);
   };

   useEffect(() => {
      console.log("MAIN isUploadPage:", isUploadPage);
   }, [isUploadPage]);

   return (
      <FullScreenDropzone
         ref={dropzoneRef}
         onDrop={handleDrop}
         onDropReject={handleDropReject}
         isUploadPage={isUploadPage}>
         <Sidebar />
         <Outlet   context={{
          openFileDialog: () => dropzoneRef.current?.openFileDialog(),
        }} />
      </FullScreenDropzone>
   );
}

export default Main;
